import React from 'react';

import SEO from '../components/seo';
import AppWorkContent from '../components/white-label/app-work';
import AugmentedRealityContent from '../components/white-label/augmented-reality';
import BrandedAppsContent from '../components/white-label/branded-apps';
import ContactUsContent from '../components/white-label/contact-us';
import PlansContent from '../components/white-label/plans';
import PricingContent from '../components/white-label/pricing';
import ProcessWorkContent from '../components/white-label/process-work';
import TitleBlockContent from '../components/white-label/title-block';

const WhiteLabelPage = () => {
  return (
    <>
      <SEO title="AR White Label Builder" />
      <TitleBlockContent />
      <AugmentedRealityContent />
      <ProcessWorkContent />
      <AppWorkContent />
      <BrandedAppsContent />
      <PricingContent />
      <PlansContent />
      <ContactUsContent />
    </>
  );
};

export default WhiteLabelPage;
